import { StringFormat } from "@packages/common";
import type { VehicleTypeDTO } from "../dtos";
import type { SearchResultDTO } from "../dtos/api/search-result.dto";

export abstract class URLTransformer {
  static transform(item: SearchResultDTO, vehicleType: VehicleTypeDTO): string {
    if (!item) return "";

    const make = StringFormat.formatSlug(item.Specification?.Make?.Value);
    const model = StringFormat.formatSlug(item.Specification?.Model?.Value);
    const version = StringFormat.formatSlug(item.Specification?.Version?.Value);

    const numberPorts = item.Specification?.NumberPorts || "";
    const uniqueId = item.UniqueId || "";

    const yearFabrication =
      item.Specification?.YearFabrication ===
      String(item.Specification?.YearModel)
        ? item.Specification.YearModel
        : `${item.Specification?.YearFabrication}-${item.Specification?.YearModel}`;

    const cubicCentimeter = item.Specification?.CubicCentimeter || "";

    const urlSegment =
      vehicleType === "car"
        ? `${make}/${model}/${version}/${numberPorts}-portas/${yearFabrication}/${uniqueId}`
        : `${make}/${model}/${cubicCentimeter}cc/${yearFabrication}/${uniqueId}`;

    return `comprar/${urlSegment}`;
  }
}
